import { render, staticRenderFns } from "./ProductoListaItemTalleColor.vue?vue&type=template&id=70101cd2&"
import script from "./ProductoListaItemTalleColor.vue?vue&type=script&lang=js&"
export * from "./ProductoListaItemTalleColor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports